import React, { useState, useEffect } from "react";
import "../blocks/EditConcertModal.css";

function EditConcertModal({
  concert,
  onClose,
  onSave,
  isLoading = false,
  error = null,
  onCloseError,
}) {
  const [formData, setFormData] = useState({
    city: "",
    club: "",
    address: "",
    date: "",
    time: "",
    ticketLink: "",
  });

  useEffect(() => {
    if (concert) {
      setFormData({
        city: concert.city || "",
        club: concert.club || "",
        address: concert.address || "",
        date: concert.date || "",
        time: concert.time || "",
        ticketLink: concert.ticketLink || "",
      });
    }
  }, [concert]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && !isLoading) {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose, isLoading]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ ...formData, id: concert.id, _id: concert._id });
  };

  const handleOverlayClick = (e) => {
    if (isLoading) {
      return;
    }
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  

  if (!concert) {
    return null;
  }

  return (
    <div className="concert-modal__modal-overlay" onClick={handleOverlayClick}>
      <div className="concert-modal__modal">
        <button
          className="concert-modal__modal-close"
          onClick={() => !isLoading && onClose()}
          aria-label="Закрыть"
          disabled={isLoading}
        >
          ×
        </button>
        <h3 className="concert-modal__modal-title">Редактировать концерт</h3>

        {error && (
          <div className="concert-modal__error-banner">
            <span className="concert-modal__error-text">{error}</span>
            <button
              className="concert-modal__error-close"
              onClick={onCloseError}
              aria-label="Закрыть уведомление"
            >
              ×
            </button>
          </div>
        )}

        <form className="concert-modal__form" onSubmit={handleSubmit}>
          <input
            name="city"
            placeholder="Город (Н-р: в Москве)"
            value={formData.city}
            onChange={handleInputChange}
            className="concert-modal__input"
            required
          />
          <input
            name="club"
            placeholder="Место проведения (Н-р: RNDM)"
            value={formData.club}
            onChange={handleInputChange}
            className="concert-modal__input"
            required
          />
          <input
            name="address"
            placeholder="Адрес (Н-р: Наставнический пер., 13-15 строение 3)"
            value={formData.address}
            onChange={handleInputChange}
            className="concert-modal__input"
            required
          />
          <input
            name="date"
            placeholder="Дата (Н-р: 12 сентября)"
            value={formData.date}
            onChange={handleInputChange}
            className="concert-modal__input"
            required
          />
          <input
            name="time"
            placeholder="Время (Н-р: 20:00)"
            value={formData.time}
            onChange={handleInputChange}
            className="concert-modal__input"
            required
          />
          <input
            name="ticketLink"
            placeholder="Ссылка на билет (Н-р: https://exmp-link.com/)"
            value={formData.ticketLink}
            onChange={handleInputChange}
            className="concert-modal__input"
            required
          />
          <div className="concert-modal__buttons-container">
            <button
              type="button"
              onClick={() => !isLoading && onClose()}
              className="concert-modal__button"
              disabled={isLoading}
            >
              Отмена
            </button>
            <button
              type="submit"
              className="concert-modal__button concert-modal__button--save"
              disabled={isLoading}
            >
              {isLoading ? "Сохранение..." : "Сохранить"}
            </button>
          </div>
        </form>

        {isLoading && (
          <div className="concert-modal__loading-overlay">
            <div className="concert-modal__spinner"></div>
            <span className="concert-modal__loading-text">Сохранение...</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default EditConcertModal;
